import {atom} from "recoil";
import {FilterDef} from "../../../constants/FinanceModels";

export const ID_LOADING = "LOADING";
export const ID_IMPORTED = "IMPORTED";
export const ID_PROCESSED = "PROCESSED";
export const ID_BILLABLE = "BILLABLE";
export const ID_REJECTED = "REJECTED";
export const ID_BILLED_PAID = "BILLED_PAID";
export const ID_BILLED_UNPAID = "BILLED_UNPAID";

export const COLOR_IMPORTED = 'secondary';
export const COLOR_PROCESSED = 'success';
export const COLOR_LOADING = 'info';
export const COLOR_REJECTED = 'error';
export const COLOR_BILLABLE = 'secondary';
export const COLOR_BILLED_PAID = 'success';
export const COLOR_BILLED_UNPAID = 'warning';

export const STATE_ACTIVE_TAB_ETOLL = atom<number>({
    key: 'state-active-tab-etoll',
    default: 0
});

export const STATE_DISABLE_TAB_ETOLL = atom<boolean>({
    key: "state-tab-disable-etoll",
    default: false
});
export const STATE_ETOLL_REPORT_ID = atom<string | null>({
    key: 'state-etoll-report-id',
    default: null
});

export const STATE_ETOLL_REPORT_TOTAL_COUNT = atom<any>({
    key: 'etoll-state-report-total-count',
    default: null
});

export const STATE_ETOLL_REPORT_UPLOADING = atom<File | undefined>({
    key: "etoll-state-report-uploading",
    default: undefined
});

export const STATE_ETOLL_REPORT_UPDATING = atom<boolean>({
    key: "etoll-state-report-updating",
    default: false
});

export const STATE_ETOLL_REPORT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'etoll-state-report-active-filters',
    default: []
});

export const STATE_ETOLL_CHARGES_TOTAL_COUNT = atom<number>({
    key: 'etoll-state-charges-total-count',
    default: 0
});

export const STATE_ETOLL_CHARGES_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'etoll-state-charges-active-filters',
    default: []
});

export const STATE_ETOLL_CHARGES_UPDATING = atom<boolean>({
    key: "etoll-state-charges-updating",
    default: false
});

export const DECIMAL_REG_EXP =  /^\s*-?[0-9]\d*(\.\d{0,2})?\s*$/

export const ID_FILTER_SEARCH = "search";

export const ID_FILTER_TOLL_EQUIPMENT_NUMBER = "equipmentNumber";
export const ID_FILTER_TOLL_PLATE = "plate";
export const ID_FILTER_TOLL_ENTRY_DATE_FROM = "tollDateFrom";
export const ID_FILTER_TOLL_ENTRY_DATE_TO = "tollDateTo";
export const ID_FILTER_TOLL_EXIT_NAME = "exitTollName";
export const ID_FILTER_TOLL_VAT_RATE = "vatRate";
export const ID_FILTER_TOLL_FARE_AMOUNT_FROM = "fareAmountFrom";
export const ID_FILTER_TOLL_FARE_AMOUNT_TO = "fareAmountTo";
export const ID_FILTER_TOLL_CUSTOMER_ID = "customerId";
export const ID_FILTER_TOLL_CUSTOMER_NAME = "customerName";
export const ID_FILTER_TOLL_RA_CODE = "raCode";
export const ID_FILTER_TOLL_STATUSES = "statuses";
export const ID_FILTER_TOLL_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_TOLL_DEALERS = 'dealers';

export const ID_FILTER_REPORT_FILE_NAME = "fileName";
export const ID_FILTER_REPORT_IMPORT_DATE_FROM = "imported-date-from";
export const ID_FILTER_REPORT_IMPORT_DATE_TO = "imported-date-to";
export const ID_FILTER_REPORT_SEQUENCE_NUMBER = "sequenceNumber";
export const ID_FILTER_REPORT_VERSION = "version";
export const ID_FILTER_REPORT_TOLLS_NUMBER = "tollsNumber";
export const ID_FILTER_REPORT_STATUSES = "statuses";
export const ID_FILTER_REPORT_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_REPORT_DEALERS = 'dealers';

export const eTollChargesDefaultValues = {
    equipmentNumber: "",
    plate: "",
    tollDateFrom: null,
    tollDateTo: null,
    exitTollName: "",
    vatRate: "",
    fareAmountFrom: "",
    fareAmountTo: "",
    customerId: "",
    raCode: "",
    selectedStatuses: [],
    dealers: [],

}

export const eTollReportsDefaultValues = {
    fileName: "",
    importDateFrom: null,
    importDateTo: null,
    sequenceNumber: "",
    version: "",
    tollsNumber: "",
    selectedStatuses: [],
    dealers: []
};
